export enum BenefitType {
    Unknown = "Unknown",
    LifeCover = "LifeCover",
    TraumaCover = "TraumaCover",
    HealthCover = "HealthCover",
    SpecialistsAndTests = "SpecialistsAndTests",
    GPCover = "GPCover",
    DentalAndOptical = "DentalAndOptical",
    MortgageRepaymentCover = "MortgageRepaymentCover",
    MortgageLifeCover = "MortgageLifeCover",
    TotalAndPermanentDisability = "TotalAndPermanentDisability",
    IncomeProtection = "IncomeProtection",
    RedundancyCover = "RedundancyCover",
    MortgageTraumaCover = "MortgageTraumaCover",
    BusinessExpenses = "BusinessExpenses",
    EasyHealth = "EasyHealth",
    GoldenLife = "GoldenLife",
    AccidentalDeath = "AccidentalDeath",
    SpecialistsAndTestsWithBD = "SpecialistsAndTestsWithBD",
    GuaranteedMedicalInsurability = "GuaranteedMedicalInsurability",
    NaturalHealthPlan = "NaturalHealthPlan",
    FamilyProtection = "FamilyProtection",
    SuperiorHealth3 = "SuperiorHealth3",
    WaiverOfPremium = "WaiverOfPremium",
    MajorMedicalExcludingDeluxe = "MajorMedicalExcludingDeluxe",
    SmartCarePlus = "SmartCarePlus",
    HealthPlus = "HealthPlus",
    CancerCover = "CancerCover",
    SmartStay = "SmartStay",
    PremierHealth = "PremierHealth",
    FuneralCover = "FuneralCover",
    AbsoluteHealth = "AbsoluteHealth"
}
